export default (view) => () => import(`@/${view}.vue`)
